
import { Component, Vue } from "vue-property-decorator"
import { State } from "vuex-class"

import { CurrentUser } from "@/types/user"
import { BaseState } from "@/store"
import api from "@/services/api"
import UserMenu from "./UserMenu.vue"
import { TenantFeatures } from "@/types/tenantFeatures"
import NotificationsMenu from "@/components/New/Page/Notifications/NotificationsMenu.vue"
import GlobalSearch from "@/components/New/Page/GlobalSearch.vue"

@Component({
	components: {
		NotificationsMenu,
		GlobalSearch,
		"notifications-button": NotificationsMenu,
		"user-menu": UserMenu
	}
})
export default class HeaderBar extends Vue {
	@State((state: BaseState) => state.me) private readonly me!: CurrentUser;

	// @State public systemUser!: SystemUser

	// private pictureError: boolean = false;
	// private pictureGuid: string = Guid.newGuid();

	/**
	 * @summary Gets a value indicating whether the header bar has its content slot occupied.
	 */
	private get hasHeaderContent (): boolean {
		return !!this.$slots["content"]
	}

	/**
	 * @summary Gets a value indicating whether the header bar has its content slot occupied.
	 */
	private get hasSubHeaderContent (): boolean {
		return !!this.$slots["sub-header"]
	}

	// TODO figure out this on system page. Will be in later phase
	private get myPictureUrl (): string {
		let imageUrl: string

		// if (this.pictureError || (!this.me && !this.systemUser)) {
		// 	imageUrl = "images/blank_user.png"
		// } else {
		// 	if (this.systemUser) {
		// 		imageUrl = this.systemUser.pictureUrl ? this.systemUser.pictureUrl : "images/blank_user.png"
		// 	} else {
		if (this.me.pictureUrl) {
			imageUrl = this.me.pictureUrl!
		} else {
			imageUrl = api.pictureUrl(this.me.id)
		}
		// 	}
		// }

		return imageUrl

		// return `${imageUrl}?p=${this.pictureGuid}`;
	}

	/**
	 * Only show new interface switch to admins if the feature is enabled
	 * @private
	 */
	private get showNewInterfaceSwitch (): boolean {
		if (!this.me || !this.me.isAdmin || !(this.me.tenantEnabledFeatures && this.me.tenantEnabledFeatures.includes(TenantFeatures.EnableV2))) {
			return false
		}

		return true
	}

	// public mounted() {
	// 	this.$root.$on("refresh-profile-picture", this.refreshProfilePicture);
	// }

	// public beforeDestroy() {
	// 	this.$root.$off("refresh-profile-picture", this.refreshProfilePicture);
	// }

	// public imageUrlError (args: any): void {
	// 	this.pictureError = true
	// }

	// private refreshProfilePicture(): void {
	// 	this.pictureGuid = Guid.newGuid();
	// }

	/**
	 * @summary Gets the breadcrumbs to be displayed in the header bar, using the route's breadcrumb metadata, or the path.
	 */
	private get breadcrumbItems (): { path: string, to: string, text: string }[] {
		let breadcrumbArray: { path: string, to: string, text: string }[] = []
		let pathArray = this.$route.path.split("/")

		pathArray.shift()
		pathArray.forEach(async (path, idx) => {
			let newItem = {
				path,
				to: breadcrumbArray[idx - 1]
					? "/" + breadcrumbArray[idx - 1].path + "/" + path
					: "/" + path,
				text: this.$route.matched[idx]?.meta?.breadcrumb || path
			}

			if (breadcrumbArray[idx - 1]?.path === "userprofile") {
				// TODO add & get from vuex as we're making this api call in the user profile page too
				const userDetails = await api.userDetails(path)
				newItem = {
					path,
					to: breadcrumbArray[idx - 1]
						? "/" + breadcrumbArray[idx - 1].path + "/" + path
						: "/" + path,
					text: userDetails.name
				}
			}

			breadcrumbArray.push(newItem)
		})

		return breadcrumbArray
	}
}
